<template>
  <g
    :transform="(flip === true ? `scale(-.6 .6) translate(-${x/.6 + 13} ${y/.6 + 17}) rotate(-90)` : `scale(.6 .6) translate(${x/.6 - 13} ${y/.6 + 17}) rotate(-90)` )"
    stroke="white"
  >
    <rect x="0" y="0" width="25" height="100" fill="white"/>
    <path
      :fill="color"
      d="M15.5.5a3.3333,3.3333,0,0,0-3.3333,3.3333V6h6.6666V3.8333A3.3333,3.3333,0,0,0,15.5.5Z"
    />
    <rect :fill="color" x="6.5" y="6" width="18" height="8"/>
    <polygon :fill="color" points="30.5 66 0.5 66 0.5 18.5 3.5 14 27.5 14 30.5 18.5 30.5 66"/>
    <polygon :fill="color" points="27.5 84 3.5 84 0.5 88.5 0.5 98 30.5 98 30.5 88.5 27.5 84"/>
    <polygon :fill="color" points="29.5 66 1.5 66 3.5 84 27.5 84 29.5 66"/>
    <path :fill="color" d="M15.5,30a3,3,0,0,0-3,3V46h6V33A3,3,0,0,0,15.5,30Z"/>
    <g :fill="color">
      <line :fill="color" x1="1" y1="79.5" x2="31" y2="79.5"/>
      <line :fill="color" x1="1" y1="75" x2="31" y2="75"/>
      <line :fill="color" x1="1" y1="70.5" x2="31" y2="70.5"/>
    </g>
    <path
      fill="#e0e0e0"
      d="M15.5.5a3.3333,3.3333,0,0,0-3.3333,3.3333V6h6.6666V3.8333A3.3333,3.3333,0,0,0,15.5.5Z"
    />
    <rect fill="#d2d2d2" x="6.5" y="6" width="18" height="8"/>
    <polygon :fill="color" points="30.5 66 0.5 66 0.5 18.5 3.5 14 27.5 14 30.5 18.5 30.5 66"/>
    <polygon :fill="color" points="27.5 84 3.5 84 0.5 88.5 0.5 98 30.5 98 30.5 88.5 27.5 84"/>
    <polygon :fill="color" points="29.5 66 1.5 66 3.5 84 27.5 84 29.5 66"/>
    <path :fill="color" d="M15.5,30a3,3,0,0,0-3,3V46h6V33A3,3,0,0,0,15.5,30Z"/>
    <g :fill="color">
      <line :fill="color" x1="1" y1="79.5" x2="31" y2="79.5"/>
      <line :fill="color" x1="1" y1="75" x2="31" y2="75"/>
      <line :fill="color" x1="1" y1="70.5" x2="31" y2="70.5"/>
    </g>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 50,
      plugHeight: 15
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color () { return this.getCssColor(this.plugColor)},
    yRecalculated () { return this.y - this.plugHeight / 2}
  },
  methods: {
    getColor (colorName) { return this.getCssColor(colorName)},
    getNoseColor (colorName) { return this.getCssColor(colorName + "Nase")}
  }
}
</script>